import script from "./DeviceUtilization.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceUtilization.vue?vue&type=script&setup=true&lang=js"

import "./DeviceUtilization.vue?vue&type=style&index=0&id=7e4964dc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e4964dc"]])

export default __exports__